import Typography from '@mui/material/Typography';
import { Trans, useTranslation } from 'react-i18next';

import { useValidUntil } from '../../../viewers/ViewerContainer/utils/useValidUntil';

import { VersionLabel } from '@egr/xbox/utils/Version';
const versionStyle: React.CSSProperties = {
    position: 'absolute',
    right: '24px',
};

export const FooterInfo: React.FC = () => {
    const { t } = useTranslation();

    const validUntil = useValidUntil();
    if (!validUntil) {
        return (
            <Typography
                variant="footer"
                style={versionStyle}
                data-testid="footer-info"
            >
                {VersionLabel}
            </Typography>
        );
    }
    return (
        <Typography
            variant="footer"
            style={versionStyle}
            data-testid="footer-info"
        >
            <Trans t={t} i18nKey="Available until: <1>{{validUntil}}</1>" values={{ validUntil }} components={{ 1: <b /> }} />
        </Typography>
    );
};
